"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClearCartButton = void 0;
const React = require("react");
const react_1 = require("react");
const useRequiredContext_1 = require("../../../../../../hooks/useRequiredContext");
const SalesOrderContext_1 = require("../../../contexts/SalesOrderContext");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../../helpers/cssComposer");
const Button_1 = require("../../../../../../components/base/atoms/Button");
const Modal_1 = require("../../../../../../components/base/structure/Modal");
const css = (0, cssComposer_1.default)(styles, "ClearCartButton");
const ClearCartButton = ({ editable }) => {
    const { resetCart } = (0, useRequiredContext_1.useRequiredContext)(SalesOrderContext_1.SalesOrderContext);
    const [showClearCartConfirm, setShowClearCartConfirm] = (0, react_1.useState)(false);
    if (!editable) {
        return null;
    }
    return (React.createElement("div", { className: css("") },
        React.createElement(Button_1.Button, { className: css("button"), onClick: () => setShowClearCartConfirm(true) }, "clear cart"),
        React.createElement(Modal_1.Modal, { onClose: null, open: showClearCartConfirm },
            React.createElement(Modal_1.ModalHeader, null, "Are you sure you want to clear you cart?"),
            React.createElement(Modal_1.ModalFooter, { onAccept: () => {
                    resetCart(false);
                    setShowClearCartConfirm(false);
                }, acceptLabel: "clear", onCancel: () => setShowClearCartConfirm(false) }))));
};
exports.ClearCartButton = ClearCartButton;
//# sourceMappingURL=index.js.map